import { render, staticRenderFns } from "./BillVatInvoiceModal.vue?vue&type=template&id=353db6e8"
import script from "./BillVatInvoiceModal.vue?vue&type=script&lang=js"
export * from "./BillVatInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./BillVatInvoiceModal.vue?vue&type=style&index=0&id=353db6e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports